import {BasePanelPageStyle} from "../../panels/BasePanelPage";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";

export class InlineUserDashboardPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    panelPage = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
    };

    @styleRule
    link = this.themeProps.PANEL_LINK;
}
